export const FETCH_CLINIC_REQUEST = "FETCH_CLINIC_REQUEST";
export const UPDATE_CLINIC_REQUEST = "UPDATE_CLINIC_REQUEST";
export const CHANGE_CLINIC_STATUS_REQUEST = "CHANGE_CLINIC_STATUS_REQUEST";
export const UPDATE_WEIGHT_REQUEST = "UPDATE_WEIGHT_REQUEST";
